import type { components } from 'generated/api'
import Api from 'utils/api'

type Schemas = components['schemas']

export type Project = Schemas['Project']
export type ProjectDetail = Schemas['ProjectDetail']
export type ProjectPayload = Schemas['PatchedProjectCreateUpdateRequest']
export type ProjectProfile = Schemas['JobProfile']
export type ProjectModules = Schemas['ModuleSelection']

interface FetchProjectsParams {
  limit?: number
  offset?: number
  ordering?: string[]
  search?: string
  department?: number | string
}

export const fetchProjects = ({
  limit,
  offset,
  ordering,
  search,
  department,
}: FetchProjectsParams) =>
  Api.get(['projects'], { limit, offset, ordering, search, department })
